import brandInfo from '../../../environments/brand.json';
import { environment } from '../../../environments/environment';

/**
 * When frontend.useAdminConfig is true, database values override the baked
 * brand file. Otherwise the repo file stays in place.
 */
export function loadBrandConfig(): () => Promise<void> {
  return async () => {
    const info = brandInfo as { brand?: string; name?: string };
    const brandName = info.brand || info.name;
    const apiUrl = environment.apiUrl;
    if (!brandName || !apiUrl) {
      return;
    }

    const url =
      `${apiUrl.replace(/\/$/, '')}/v1/api/brands/` +
      `${encodeURIComponent(brandName)}/frontend-config`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        return;
      }
      const payload = await response.json();
      const frontend = payload?.data?.frontend;
      if (!frontend || frontend.useAdminConfig !== true) {
        return;
      }
      Object.assign(brandInfo, frontend);
    } catch {
      return;
    }
  };
}
